import startsWith from 'lodash/startsWith';

export const isBase64 = str =>
  startsWith(str, 'data:image/jpeg;base64') ||
  startsWith(str, 'data:image/png;base64') ||
  startsWith(str, 'data:audio/mpeg;base64') ||
  startsWith(str, 'data:audio/wav;base64') ||
  startsWith(str, 'data:audio/x-m4a;base64') ||
  startsWith(str, 'data:audio/m4a;base64') ||
  startsWith(str, 'data:audio/mp4;base64');

export const isJSON = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
